import styled, { css } from "styled-components";

// ======================
// Funções auxiliares
// ======================

/**
 * Mapeia a string de cor (ex: 'from-blue-500 to-blue-600')
 * para um gradiente real.
 */

// ======================
// Layout Geral
// ======================

export const Content = styled.div`
  padding: 30px;
  margin-top: 100px;
  width: 100%;
  background-color: #f5f5f5;
`;

export const Container = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 100%;
  min-height: 80vh;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

// ======================
// Header
// ======================

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
`;

export const HeaderIcon = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(to right, #3b82f6, #2563eb);
  border-radius: 8px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderTitle = styled.h1`
  font-family: Inter;
  font-weight: 600;
  font-size: 24px;
  line-height: 29.05px;
  letter-spacing: -1%;
  background: linear-gradient(to right, #1f2937, #4b5563);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

// ======================
// Regionais (grid cards)
// ======================

export const RegionalsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 24px;

  /* Responsivo */
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

interface RegionalCardProps {
  isActive?: boolean;
}
export const RegionalCard = styled.div<RegionalCardProps>`
  border: 1px solid #e2e2e2;
  border-radius: 12px;
  overflow: hidden;

  /* Sombra padrão no card */
  box-shadow: 0px 4px 4px 0px #00000040;
  margin-bottom: 8px;
`;

export const RegionalCardHeader = styled.div`
  padding: 24px;
  /* Gradiente dinâmico */
  background: #f5f5f5;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RegionalLine: any = styled.div`
  width: 100%;
  height: 3px;
  background-color: ${(props: any) => props.corDestaque || "#bd1622"};
`;

export const RegionalIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: Inter;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: -1%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  background-color: #fff;
  border-radius: 50%;
  width: 80px;
  height: 80px;
`;

export const RegionalInfos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 8px;
  font-family: Inter;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: -1%;
`;

export const RegionalTextInfo = styled.p`
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: -1%;
  color: #646363;
`;

export const RegionalBandeiraImg = styled.img`
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  object-fit: cover;
`;

export const RegionalCardBody = styled.div`
  padding: 16px;
`;

export const Top3Title = styled.h3`
  font-size: 0.875rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 16px;
`;

export const Top3Item = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ButtonSeeMore = styled.button`
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 16.94px;
  letter-spacing: -1%;
  color: #2563eb;
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

// Badge da posição

export const Avatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const RankInfo = styled.div`
  flex: 1;

  p {
    font-family: Inter;
    font-weight: 700;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: -1%;
  }

  span {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: -1%;
  }
`;

export const PointsInfo = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  line-height: 16.94px;
  letter-spacing: -1%;

  color: #4b5563;
`;

// ======================
// Detalhes da Regional Selecionada
// ======================

export const DetailedRanking = styled.div`
  border: 1px solid #e2e2e2;
  border-radius: 12px;
  margin-top: 32px;
  overflow: hidden;
`;

interface DetailedRankingHeaderProps {
  color: string;
}
export const DetailedRankingHeader = styled.div<DetailedRankingHeaderProps>`
  padding: 24px;
  background: ${({ color }) => color};
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  > div {
    h2 {
      font-family: Inter;
      font-weight: 700;
      font-size: 18px;
      line-height: 21.78px;
      letter-spacing: -1%;
      color: #fff;
    }
    p {
      font-size: 0.875rem;
      color: rgba(255, 255, 255, 0.8);
      margin: 0;
    }
  }
`;

export const Filters = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const SearchWrapper = styled.div`
  position: relative;
  color: blue;
  display: flex;
  align-items: center;

  svg {
    position: absolute;
    left: 12px;
  }

  input {
    padding: 8px 12px 8px 36px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background-color: blue;
    min-width: 200px;

    &::placeholder {
      color: black;
    }

    &:focus {
      outline: 2px solid rgba(255, 255, 255, 0.5);
      border-color: transparent;
    }
  }
`;

export const DetailedRankingList = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #f9fafb;
`;

export const DetailedRankingItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: rgba(0, 0, 0, 0.02);
  padding: 16px;
  border-radius: 12px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f3f4f6;
  }

  h3 {
    font-family: Inter;
    font-weight: 700;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: -1%;
    color: #000000;
  }

  span {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: -1%;
    color: #000000;
  }
`;

export const AvatarBig = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
`;

export const PointsGradient = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  line-height: 16.94px;
  letter-spacing: -1%;

  color: #4b5563;
  margin-left: auto;
`;

export const ContainerFooter = styled.div`
  display: flex;
  padding: 24px;
  justify-content: center;
`;
